var map = {
	"./prize-1-bm.webp": 2585,
	"./prize-1-cn.webp": 2586,
	"./prize-1.webp": 2587,
	"./prize-2-bm.webp": 2588,
	"./prize-2-cn.webp": 2589,
	"./prize-2.webp": 2590,
	"./prize-3-bm.webp": 2591,
	"./prize-3-cn.webp": 2592,
	"./prize-3.webp": 2593,
	"./prize-4-bm.webp": 2594,
	"./prize-4-cn.webp": 2595,
	"./prize-4.webp": 2596,
	"./star.svg": 2597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 934;